/**
 *
 * SurveyConfig
 *
 */

import React, { Component } from "react"
// import PropTypes from 'prop-types';
import { isEqual, pick, map } from "lodash"
import "./index.less"
import { Popover } from "antd"
import messageConfigFocus from "../../images/message-config-focus.svg"
import messagesConfig from "../../images/message-config.svg"
import pallete from "../../images/pallete.svg"
import palleteFocus from "../../images/pallete-focus.svg"
import settings from "../../images/settings.svg"
import settingsFocus from "../../images/settings-focus.svg"
import FirstStepConfig from "./FirstStepConfig"
import SecondStepConfig from "./SecondStepConfig"
import ThirdStepConfig from "./ThirdStepConfig"
import { woopraTrack } from "../../utils/woopra/woopraTracker"

class SurveyConfig extends Component {
  state = {
    optionSelected: 1,
    title: "",
    message_start: "",
    message_end: "",
    button_end_text: "",
    button_start_text: "",
    color_button: "",
    color_text_likert: "",
    color_text_question: "",
    background_color: "",
    likert_text_left: "",
    likert_text_center: "",
    likert_text_right: "",
    company_logo: "",
    background_image: "",
    order_random: false,
    display_number: false,
    display_progress_bar: false,
    background_image_opacity: 100,
    company_logo_opacity: 100,
    questions: [],
    settingOriginal: "",
    editSettingSegment: [],
  }

  componentDidMount = () => {
    woopraTrack("Configuración de cuestionario")
    this.updateAllState()
    this.setState({
      background_image:
        this.props.uploadBgImage.pathImage ||
        this.props.uploadBgImage.defaultImage,
      company_logo: this.props.uploadLogo || "",
      questions: map(this.props.questions.questions, (item, index) => ({
        ...item,
        order: index + 1,
      })),
    })
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.order_random !== this.state.order_random) {
      let addingNumberToArray = map(
        this.props.questions.questions,
        (item, index) => ({ ...item, order: index + 1 })
      )

      if (this.state.order_random) {
        addingNumberToArray = this.shuffle(addingNumberToArray)
      }

      this.setState({ questions: addingNumberToArray })
    }

    if (!isEqual(prevProps.configSurvey, this.props.configSurvey)) {
      this.updateAllState()
    }

    if (!isEqual(prevProps.uploadBgImage, this.props.uploadBgImage)) {
      this.setState({
        background_image:
          this.props.uploadBgImage.pathImage ||
          this.props.uploadBgImage.defaultImage,
      })
    }

    if (prevProps.uploadLogo !== this.props.uploadLogo) {
      this.setState({ company_logo: this.props.uploadLogo || "" })
    }
  }

  shuffle = (array) => {
    let currentIndex = array.length
    let temporaryValue
    let randomIndex

    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex)
      currentIndex -= 1

      temporaryValue = array[currentIndex]
      array[currentIndex] = array[randomIndex]
      array[randomIndex] = temporaryValue
    }

    return array
  }

  updateAllState = () => {
    const { configSurvey } = this.props

    this.setState({
      ...this.props.configSurvey,
      settingOriginal: configSurvey,
      editSettingSegment: this.state.editSettingSegment,
      background_image:
        this.props.configSurvey.background_image ||
        this.props.uploadBgImage.defaultImage,
    })
  }

  saveAttributesSegment = (name, value) => {
    const { editSettingSegment, settingOriginal } = this.state
    const valueOriginal = settingOriginal[name]
    const index = editSettingSegment.indexOf(name)
    if (valueOriginal != value && index == -1) {
      editSettingSegment.push(name)
    } else if (
      (valueOriginal === value && index != -1) ||
      (value === "" && typeof valueOriginal === "undefined") ||
      value === "delete"
    ) {
      editSettingSegment.splice(index, 1)
    }
    return editSettingSegment
  }

  setStateFrom = (name, value) => {
    this.setState({
      [name]: value,
      editSettingSegment: this.saveAttributesSegment(name, value),
    })
  }
  
  render() {
    const hasFreshchat =
      typeof window.Intercom !== "undefined" &&
      window.self === window.top;
    return (
      <div className={`survey-config-container ${hasFreshchat ? "hasPaddingChatSurvey" : ""}`}>
        <div className="survey-config-menu">
          <Popover placement="right" content="Mensaje">
            <div
              className={
                this.state.optionSelected === 1
                  ? "survey-config-menu-active"
                  : ""
              }
              onClick={() => this.setStateFrom("optionSelected", 1)}>
              <img
                src={
                  this.state.optionSelected === 1
                    ? messageConfigFocus
                    : messagesConfig
                }
              />
            </div>
          </Popover>

          <Popover placement="right" content="Diseño">
            <div
              className={
                this.state.optionSelected === 2
                  ? "survey-config-menu-active"
                  : ""
              }
              onClick={() => this.setStateFrom("optionSelected", 2)}>
              <img
                src={this.state.optionSelected === 2 ? palleteFocus : pallete}
              />
            </div>
          </Popover>

          <Popover placement="right" content="Preferencia">
            <div
              className={
                this.state.optionSelected === 3
                  ? "survey-config-menu-active"
                  : ""
              }
              onClick={() => this.setStateFrom("optionSelected", 3)}>
              <img
                src={this.state.optionSelected === 3 ? settingsFocus : settings}
              />
            </div>
          </Popover>
        </div>
        <div>
          {this.state.optionSelected === 1 && (
            <FirstStepConfig
              updateAllState={this.updateAllState}
              id_survey={this.props.configSurvey.id_survey}
              setStateFrom={this.setStateFrom}
              editSettingSegment={this.state.editSettingSegment}
              {...pick(this.state, [
                "background_color",
                "button_end_text",
                "button_start_text",
                "message_end",
                "message_start",
                "title",
                "color_button",
                "background_image",
                "background_image_opacity",
                "company_logo",
                "company_logo_opacity",
              ])}
              {...pick(this.props, [
                "configSurvey",
                "measures",
                "updateConfigSurveyWatcher",
                "uploadBgImage",
              ])}
            />
          )}
          {this.state.optionSelected === 2 && (
            <SecondStepConfig
              updateAllState={this.updateAllState}
              id_survey={this.props.configSurvey.id_survey}
              setStateFrom={this.setStateFrom}
              editSettingSegment={this.state.editSettingSegment}
              {...pick(this.state, [
                "display_progress_bar",
                "display_number",
                "likert_text_right",
                "likert_text_center",
                "likert_text_left",
                "background_color",
                "color_text_question",
                "color_text_likert",
                "color_button",
                "background_image",
                "company_logo",
                "background_image_opacity",
                "company_logo_opacity",
                "questions",
              ])}
              {...pick(this.props, [
                "updateConfigSurveyWatcher",
                "measures",
                "configSurvey",
                "uploadBgImageWatcher",
                "uploadBgImage",
                "isLoadingUploadBgImage",
                "uploadLogoWatcher",
                "uploadLogo",
                "isLoadingUploadLogo",
              ])}
            />
          )}
          {this.state.optionSelected === 3 && (
            <ThirdStepConfig
              updateAllState={this.updateAllState}
              setStateFrom={this.setStateFrom}
              id_survey={this.props.configSurvey.id_survey}
              editSettingSegment={this.state.editSettingSegment}
              {...pick(this.state, [
                "color_text_likert",
                "background_color",
                "color_text_question",
                "color_button",
                "display_progress_bar",
                "display_number",
                "likert_text_right",
                "likert_text_center",
                "likert_text_left",
                "order_random",
                "background_image",
                "company_logo",
                "background_image_opacity",
                "company_logo_opacity",
                "questions",
              ])}
              {...pick(this.props, [
                "updateConfigSurveyWatcher",
                "measures",
                "configSurvey",
                "uploadBgImage",
                "isLoadingUploadBgImage",
              ])}
            />
          )}
        </div>
      </div>
    )
  }
}

SurveyConfig.propTypes = {}

export default SurveyConfig
